import { render, staticRenderFns } from "./SubscriptionLoading.vue?vue&type=template&id=283b5c1e"
import script from "./SubscriptionLoading.vue?vue&type=script&lang=js"
export * from "./SubscriptionLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports